const l = {
  name: "CrossCircleSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4144 12L15.4144 14L14.0002 15.4142L12.0002 13.4142L10.0002 15.4142L8.58594 14L10.5859 12L8.58594 10L10.0002 8.58582L12.0002 10.5858L14.0002 8.58582L15.4144 10L13.4144 12Z" fill="currentColor"/>
<path d="M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as CrossCircleSmall
};
